import { flushSync } from "react-dom";

// Apply a state mutation (e.g. inserting a question) without the page visually
// jumping. We anchor to the topmost question card currently in view, flush the
// update synchronously so the DOM reflects it, then scroll by however far that
// anchor moved — keeping whatever the user is looking at exactly where it was.
//
// Used when adding/scoring items so the new card (which may land above the
// viewport) doesn't slide the rest of the list around.
export function withPreservedScroll(mutate: () => void) {
  const cards = document.querySelectorAll<HTMLElement>('[id^="question-card-"]');
  let anchorEl: HTMLElement | null = null;
  let anchorTop = 0;
  for (const el of Array.from(cards)) {
    const rect = el.getBoundingClientRect();
    // First card whose bottom is below the viewport top — i.e. the topmost
    // card the user can (at least partly) see.
    if (rect.bottom > 0) {
      anchorEl = el;
      anchorTop = rect.top;
      break;
    }
  }

  flushSync(mutate);

  if (anchorEl) {
    const delta = anchorEl.getBoundingClientRect().top - anchorTop;
    if (delta) window.scrollBy(0, delta);
  }
}
